module.exports = __webpack_public_path__ + "assets/img/6.eb8c4a0f.png";